import { useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import styles from "./UploadButton.module.scss";

interface UploadButtonProps {
  /**
   * Callback invoked when the user selects files via the file picker.
   */
  onFileSelect: (files: File[]) => void | Promise<void>;
  /**
   * Disables the button and prevents file selection.
   */
  disabled?: boolean;
}

export default function UploadButton({
  onFileSelect,
  disabled = false,
}: UploadButtonProps) {
  const { getInputProps, open } = useDropzone({
    onDrop: async (files) => {
      if (disabled) return;
      await onFileSelect(files);
    },
    noDrag: true,
  });

  const tooltipContent = disabled ? (
    "File uploads are not available"
  ) : (
    <>
      <div>Upload documents or images to add to the chat.</div>
      <div>(Only plain text, PDF, DOCX, PNG, or JPG files)</div>
    </>
  );

  return (
    <>
      <input {...getInputProps()} />
      <Tippy content={tooltipContent} placement="right">
        <span>
          <button
            type="button"
            className={`${styles.menuItem} ${disabled ? styles.disabled : ""}`}
            onClick={open}
            disabled={disabled}
          >
            <FontAwesomeIcon icon={faPaperclip} className={styles.icon} />
            Upload files & images
          </button>
        </span>
      </Tippy>
    </>
  );
}
